<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('customer management')"
      :columns="columns"
      :column_search="false"
      resource_url="/archive/customer/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create_customer">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Customer CRUD Modal -->
    <customer-modal ref="customer_modal" @success="refresh_datatable" />

    <!-- Customer Detail Modal -->
    <customer-detail-modal ref="customer_detail_modal" @edit="edit_customer" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
} from "@/utils";
import CustomerModal from "./customer_modal/Index.vue";
import CustomerDetailModal from "./customer_detail_modal/Index.vue";

export default {
  name: "CustomersDataTable",
  components: {
    GenericTable,
    "customer-modal": CustomerModal,
    "customer-detail-modal": CustomerDetailModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("customer name"),
          name: "name",
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${row.name || ""}</div>
                    <div class="subtitle is-7 has-text-grey">${
                      row.identification_number || ""
                    }</div>`;
          },
        },
        {
          title: this.$t("identification number"),
          name: "identification_number",
          searchable: true,
          data: (row) => row.identification_number || "",
        },
        {
          title: this.$t("expedient count"),
          name: "expedient_count",
          data: (row) => {
            return row.expedient_count || 0;
          },
        },
        {
          title: this.$t("created date"),
          name: "create_date",
          data: (row) => {
            return row.create_date ? format_date(row.create_date) : "";
          },
        },
        {
          title: this.$t("actions"),
          width: "25%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  v.$refs.customer_detail_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_customer(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  v.delete_customer(e.detail.uuid);
                },
              },
            ];
            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create_customer() {
      this.$refs.customer_modal.show_modal();
    },

    edit_customer(uuid) {
      this.$refs.customer_modal.show_modal(uuid);
    },

    delete_customer(uuid) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure delete customer"), v, () => {
        del("/archive/customer", { uuid: uuid })
          .then(() => {
            v.refresh_datatable();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },

    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.$refs.datatable.refresh();
  },
};
</script>

<style scoped>
.title.is-6 {
  margin-bottom: 0.25rem;
}

.subtitle.is-7 {
  margin-bottom: 0;
}
</style>
